import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentDefinition } from '../../models/agent.models';

@Component({
  selector: 'app-agent-card',
  templateUrl: './agent-card.component.html',
  styleUrls: ['./agent-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentCardComponent {
  @Input({ required: true }) agent!: AgentDefinition;
  @Output() readonly talk = new EventEmitter<string>();

  get isLocked(): boolean { return this.agent.status === 'locked'; }
}
